import {MidiDeviceHolder} from "./MidiDeviceHolder";
import {MidiMessage} from "./MidiMessage";

enum MidiDeviceCategory {
    Physical,
    Recorder
}

enum MidiDeviceDirection {
    Input,
    Output
}

export {Midi, MidiDeviceCategory, MidiDeviceDirection}

class Midi {

    midi!: WebMidi.MIDIAccess;
    callbacks: Array<(midi: MidiMessage, outputs: Array<MidiDeviceHolder>) => void> = [];
    midiDevices: Array<MidiDeviceHolder> = [];

    public async init() {
        this.midi = await navigator.requestMIDIAccess();
        this.midi.onstatechange = () => this.registerSystemMidiDevices;
        this.registerSystemMidiDevices();
    }

    public registerCallback(callback: (e: MidiMessage, outputs: Array<MidiDeviceHolder>) => void) {
        this.callbacks.push(callback);
    }

    private midiCallback(midiEvent: MidiMessage) {
        this.callbacks.forEach((callback) => callback(midiEvent, this.midiDevices));
    }

    public addMidiDevice(midiDevice: MidiDeviceHolder) {
        midiDevice.setOnMidiMessage(
            (message) => this.midiCallback(new MidiMessage(message, midiDevice))
        );
        this.midiDevices.push(midiDevice);
    }

    private removeMidiDevice(midiDevice: MidiDeviceHolder) {
        midiDevice.setOnMidiMessage((e: WebMidi.MIDIMessageEvent) => {
        });
        this.splice(this.midiDevices, midiDevice);
    }

    private splice(array: Array<Object>, objectToRemove: Object) {
        const index = array.indexOf(objectToRemove, 0);
        if (index > -1) {
            this.midiDevices.splice(index, 1);
        }
    }

    public registerSystemMidiDevices() {
        this.readCurrentMidiInputs();
        this.readCurrentMidiOutputs();
    }

    private readCurrentMidiInputs() {
        const systemMidiInputs = Array.from(this.midi.inputs.values());
        this.removeDisconnectedInputs(systemMidiInputs);
        this.addNewDevices(systemMidiInputs);
    }

    private addNewDevices(systemMidiInputs: WebMidi.MIDIInput[]) {
        systemMidiInputs
            .filter(input => !this.midiDevices.find(midiInput => midiInput.input === input))
            .forEach((input) => this.addMidiDevice(
                new MidiDeviceHolder(input, MidiDeviceCategory.Physical)));
    }

    private removeDisconnectedInputs(systemMidiInputs: WebMidi.MIDIInput[]) {
        this.midiDevices
            .filter(input => !systemMidiInputs.find(sysIn => sysIn === input.input))
            .filter(input => input.category === MidiDeviceCategory.Physical)
            .filter(output => output.direction === MidiDeviceDirection.Input)
            .forEach((input) => this.removeMidiDevice(input));
    }

    private readCurrentMidiOutputs() {
        const systemMidiOutputs = Array.from(this.midi.outputs.values());
        this.midiDevices
            .filter(output => !systemMidiOutputs.find(sysOut => sysOut === output.output))
            .filter(output => output.category === MidiDeviceCategory.Physical)
            .filter(output => output.direction === MidiDeviceDirection.Output)
            .forEach((output) => this.removeMidiDevice(output));
        systemMidiOutputs
            .filter(output => !this.midiDevices.find(midiOut => midiOut.output === output))
            .forEach((output) => this.addMidiDevice(
                new MidiDeviceHolder(output, MidiDeviceCategory.Physical)));
    }
}
